<div
  class="tw-overflow-hidden tw-bg-[#00000080] tw-text-[#000000de] tw-absolute tw-inset-0 tw-z-[2000]"
>
  <div class="tw-flex-center tw-flex-col tw-h-full">
    <div class="center-box">
      <div>
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="tw-mt-3">
        <div [innerHTML]="message"></div>
      </div>
    </div>
  </div>
</div>
